import { Components, Theme } from '@mui/material/styles';

export const buttonTheme: Components<Theme>['MuiButton'] = {
  defaultProps: {
    // Flat buttons app-wide, pairing with the no-caps style below.
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      textTransform: "none",
    },
  },
};
